<div class="content">
  <h1>PRIVACY STATEMENT ON PERSONAL DATA PROCESSING</h1>
  <p>
    This Privacy Statement on Personal Data Processing for Smart Waste Control (“Application”) is designed to inform you
    about
    the processing of your Personal Data by ISS World Services A/S with its registered office at Buddingevej 197, 2860
    Søborg, Denmark CVR 10161614 (“ISS”, "we", "us", and "our") with regard to your use of the Application, and about
    your
    rights regarding this processing (“Privacy Statement") in accordance with Regulation (EU) 2016/679 of the European
    Parliament and of the Council of 27 April 2016 on the protection of natural persons with regard to the processing of
    personal data and on the free movement of such data, and repealing Directive 95/46/EC (General Data Protection
    Regulation ("GDPR") and any other applicable law.
  </p>
  <p>
    ISS is committed to protecting your privacy and handling your data in an open and transparent manner. The Waste
    Order
    2.0 is a web-based application designed to streamline waste management services, allowing for the scheduling and
    ordering of specific waste stream services such as collections, container cleaning, and relocation among others.
  </p>
  <p>
    This application facilitates communication and operations between customers, ISS employees, and suppliers. Upon
    registering and accepting our Terms and Conditions and Privacy Notice, you will be able to access the full range of
    services offered by the application and ISS.
  </p>
  <h2>Definitions</h2>
  <dl>
    <dt>Data Controller</dt>
    <dd>shall mean the natural or legal person, public authority, agency or other body which alone or jointly with
      others, determines the purposes and means of the processing of Personal Data. In relation to the processing
      described in this Privacy Statement, the Data Controller is ISS World Services A/S with its registered office at
      Buddingevej 197, 2860 Søborg, Denmark CVR 10161614.
    </dd>
    <dt>Data Subject and Application User</dt>
    <dd>shall mean an identified or identifiable natural person. For the purpose of this Privacy Statement, the Data
      Subject is the Application User - an employee, independent contractor or other individual that is authorized,
      directly or indirectly, to use the Application.
    </dd>
    <dt>Personal Data</dt>
    <dd>means any information relating to an identified or identifiable natural person; an identifiable natural person
      is one who can be identified, directly or indirectly, in particular by reference to an identifier such as a name,
      an identification number, location data, an online identifier etc.
    </dd>
    <dt>Data Processor</dt>
    <dd>means a natural or legal person, public authority, agency or other body which processes Personal Data on behalf
      of the Data Controller.
    </dd>
    <dt>Recipient</dt>
    <dd>means a natural or legal person, public authority, agency or another body, to which the Personal Data are
      disclosed.
    </dd>
  </dl>
  <h1>CATEGORIES OF PERSONAL DATA</h1>
  <p>
    ISS processes or may process the following categories of Personal Data relating to the Application Users:
  </p>
  <ul>
    <li>Contact information about yourself including your name, surname, email address and mobile phone number;</li>
    <li>Application User credentials: username and password;</li>
    <li>Technical information of your mobile device, such as its operating system, the device and connection type and
      the
      IP address from which you are accessing our Application.
    </li>
  </ul>
  <h2>Purpose and legal basis of Personal Data processing by ISS</h2>
  <p>
    When processing your Personal Data, ISS relies on various legal bases. Each of them has been summarized below with a
    description of respective uses of each of legal bases and corresponding purposes:
  </p>
  <ul>
    <li>Performance of a contract: ISS processes Personal Data on the grounds that they are necessary to fulfill the
      terms of our agreements with Application Users (Art. 6(1)(b) of the GDPR). On this legal basis we will process
      your Contact information, Order details and payment information as well as data about your use of the Application:
      <ul>
        <li>to enable us to provide you with access to the relevant parts of the Application;</li>
        <li>to supply the services you have requested;</li>
        <li>to contact you where necessary concerning our services, such as to resolve issues you may have with your
          order.
        </li>
      </ul>
    </li>
    <li>Legal obligation: Where ISS is under a legal obligation to process your Personal Data. On this legal basis we
      will process your Contact information, Order details and payment information as well as data about your use of the
      Application to:
      <ul>
        <li>create a record of your order(s); and</li>
        <li>comply with any legal obligation or regulatory requirement to which we are subject such as accounting;
          producing evaluations and notifications for tax authorities etc.
        </li>
      </ul>
    </li>
    <li>Legitimate interest: where the processing of your Personal Data is not strictly necessary to fulfill the terms
      of our agreements with Application Users, nor to comply with a legal obligation, but ISS has a legitimate reason
      to process your Personal Data (Art. 6(1)(f) of the GDPR). On this legal basis we will process your Contact
      information, Order details and payment information, data about your use of the Application as well as Technical
      information from your mobile device:
      <ul>
        <li>to enable our support team to help you with any enquiries or complaints in the most efficient way possible
          and to provide a positive customer experience;
        </li>
        <li>to contact you for your views and feedback on our services and to notify you if there are any important
          changes or developments to the Application or our services, including letting you know that our services are
          operating in anew area, where you have asked us to do so;
        </li>
        <li>to analyse your activity on the Application so that we can administer, support, improve and develop our
          business and for statistical and analytical purposes and to help us to prevent fraud;
        </li>
        <li>to improve the effectiveness and quality of service that our customers can expect from us in the future;
        </li>
        <li>to enforce our contractual terms with you and any other agreement, and for the exercise or defence of legal
          claims and to protect our rights (including to prevent fraud).
        </li>
      </ul>
    </li>
  </ul>
  <h2>Personal Data sources</h2>
  <p>
    We collect and/or derive Personal Data from two types of data subjects: ISS employees and supplier representatives
    who are authorized to use the Application. For ISS employees, the personal data is provided to us by their
    respective ISS Affiliates (their employers). For supplier representatives, their data is furnished by the supplying
    entity.
  </p>
  <h2>Recipients of Personal Data and Cross-border transfers</h2>
  <p>
    In order to achieve the necessary purposes of Personal Data processing, ISS discloses your Personal Data to third
    party service providers. The types of third-party service providers whom we share your information with includes IT
    service providers (including cloud providers) for the purposes of data storage and analysis.
  </p>
  <p>
    ISS and our authorized partners shall establish by contractual mechanisms, technical, physical, administrative and
    procedural safeguards, in accordance with the adopted requirements and standards, to ensure confidentiality,
    security, the integrity and availability of personal data processed and their protection against unauthorized use or
    unauthorized access to personal data, as well as to protect against breaches of data security and confidentiality.
  </p>
  <p>
    We will not disclose your personal data to third party organisations located outside the country in which we have
    received your information (as applicable) without your prior written consent, except as set out below or where
    disclosure is otherwise authorised or required by law or court/ tribunal order.
  </p>
  <p>
    We may transfer your personal data within the ISS Group, and to our operations or contractors located outside the
    EU/EEA. However, any such transfer does not change our commitment to safeguard your personal data under this Privacy
    Statement. Transfers within the ISS Group are covered by the Binding Corporate Rules (BCR).
  </p>
  <p>
    The BCR are internal rules adopted by ISS A/S and its participating corporate entities (the ISS Entities), to
    present “adequate safeguards for the protection of the privacy and fundamental rights and freedoms of data subjects”
    within the meaning of applicable data protection law, especially Applicable Member State Law. The BCR can be
    accessed by you at all times here: https://www.issworld.com/en/privacy-statement.
  </p>
  <p>
    If your personal data is transferred outside of the EU/EEA, ISS ensures an adequate level of security by
    transferring to countries approved by the EU Commission as having an adequate level of protection, or by entering
    into an appropriately drafted contract between ISS and the non-EU/EEA entity receiving the data.
  </p>
  <p>
    In order to comply with the applicable laws or in response to the applicable legal procedures, ISS may be required
    to disclose personal data to law enforcement authorities or other government agencies in accordance with data
    protection rules and provided there is a legal basis for the disclosure. If ISS is involved in a restructuring,
    merger & acquisition, or a bankruptcy or liquidation lawsuit in a given jurisdiction, your Personal ata may be
    disclosed in connection with the transaction.
  </p>
  <h2>Retention of Personal Data</h2>
  <p>
    We will not retain your information for any longer than is necessary. Information that we collect will be retained
    for as long as needed to fulfil the purposes outlined above, in line with our legitimate interest or for a period
    specifically required by applicable regulations or laws, such as retaining the information for regulatory reporting
    purposes.<br/>
    When determining the relevant retention periods, we will take into account factors including:
  </p>
  <ul>
    <li>our contractual obligations and rights in relation to the information involved;</li>
    <li>legal obligation(s) under applicable law to retain data for a certain period of time;</li>
    <li>statute of limitations under applicable law(s);</li>
    <li>our legitimate interests where we have carried out balancing tests;</li>
    <li>(potential) disputes; and</li>
    <li>guidelines issued by relevant data protection authorities.</li>
  </ul>
  <p>After the retention period lapses, we will permanently delete your Personal Data where it is no longer needed.</p>
  <h2>Provision of Personal Data by Application User</h2>
  <p>
    Depending on the circumstances and the specific purposes(s) of how we use your Personal Data processing (as outlined
    in Purpose and legal basis of Personal Data processing by ISS section above), provision of Personal Data by the
    Application User may be:
  </p>
  <ul>
    <li>a statutory requirement, generally for the processing based on legal obligation (e.g. for calculation of taxes
      due and/or social security contributions);
    </li>
    <li>a contractual requirement, generally for the processing to fulfill the terms of our agreements with Application
      Users;
    </li>
    <li>voluntary, generally for the processing based on our legitimate interest, however the provisioning of the
      Personal Data may be necessary to use the Application (as outlined in Purpose and legal basis of Personal Data
      processing by ISS section above)
    </li>
  </ul>
  <h2>Application User rights</h2>
  <p>We take reasonable steps to ensure that you are able to exercise your data protection rights. Unless stated
    otherwise in specific data protection legislation, you have the following rights: </p>
  <p>You have the right to gain access to your Personal Data and obtain a copy hereof. You also have the right to
    rectification of the Personal Data we process and the right to erasure. You may object to our processing of your
    Personal Data or request us to restrict our processing. Furthermore, you may in some cases request to obtain a copy
    of your Personal Data in a structured, commonly used, and machine-readable format and have the right to transmit
    those data to another controller (data portability). If processing of your Personal Data is based solely on your
    consent, you may withdraw your consent at any time. Please note that this does not affect our processing of your
    Personal Data prior to the withdrawal of your consent. You can also lodge a complaint to a competent data protection
    supervisory authority. You may find a list and full contact information of such supervisory authorities here: <a
      href="https://edpb.europa.eu/about-edpb/about-edpb/members_en" ref="noopener noreferrer">https://edpb.europa.eu/about-edpb/about-edpb/members_en</a>.
  </p>
  <p>If you have any questions about this Privacy Statement or if you wish to exercise your data protection rights,
    please contact ISS Group Data Protection Manager by email or in writing:
  </p>
  <p>
    E-mail: <a href="mailto:dpm@group.issworld.com">dpm@group.issworld.com</a>
  </p>
  <p>
    Address: Group Data Protection Manager, ISS A/S, Buddingevej 197, DK 2860 Soeborg, Denmark.
  </p>
  <p>
    You will not be charged for exercising your data protection rights. That said, you may be charged for additional
    copies of your Personal Data in accordance with applicable data protection law.
  </p>
  <h2>Changes to ISS Privacy Statement on Personal Data Processing</h2>
  <p>
    Any changes to our Privacy Statement will be posted to the Application and, where appropriate, we will notify you of
    the changes for example by email or push notification.
  </p>
  <p>
    This Privacy Statement was last updated: {{dateOfPublication | date}}
  </p>
</div>
